import styled from '@emotion/styled'

export const IconWrapper = styled.div`
  width: ${({size}) => size}px;
  height: ${({size}) => size}px;
  border-radius: 5px;
  background: ${({bg}) => bg};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 20px;
    height: 10px;
  }
`
